module.exports = __webpack_public_path__ + "img/left-font.9d93984c.png";